import { UpdatefirebaseService } from './../../services/updatefirebase.service';
import { GetdatafirebaseService } from './../../services/getdatafirebase.service';
import { AngularFireDatabase } from "@angular/fire/database";
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import axios from 'axios';
declare var $: any;

@Component({
  selector: 'app-groupcut',
  templateUrl: './groupcut.component.html',
  styleUrls: ['./groupcut.component.css']
})
export class GroupcutComponent implements OnInit, OnDestroy {
  // @ViewChild('tb_data1', { static: false }) Tb_data1: any;
  // @ViewChild('tb_data2', { static: false }) Tb_data2: any;
  FormCutGroup: UntypedFormGroup;
  //year: any;
  constructor(private getfirebase: GetdatafirebaseService, private upfirebase: UpdatefirebaseService
    , private firebase: AngularFireDatabase) {
    this.FormCutGroup = new UntypedFormGroup({
      //selectyear:new UntypedFormControl(),
      fmdata: new UntypedFormControl(),
      groupnameedit: new UntypedFormControl(),
      groupcodeedit: new UntypedFormControl(),
      timecut: new UntypedFormControl(),
      selectconfirm: new UntypedFormControl(),
    });
    //this.getfirebase.getYear().then((year: any) => {this.year = year.slice(3);});

  }

  year = [
    { "key": "4", "code": '2122', "code_th": '6465', "desc": "ปี.2564-2565", "status": 0, srt: 0 },
    { "key": "5", "code": '2223', "code_th": '6566', "desc": "ปี.2565-2566", "status": 0, srt: 0 },
    { "key": "6", "code": '2324', "code_th": '6667', "desc": "ปี.2566-2567", "status": 0, srt: 0 },
    { "key": "7", "code": '2425', "code_th": '6768', "desc": "ปี.2567-2568", "status": 1, srt: 1 }
  ]

  DataByZone = [];
  ngOnInit(): void {
    this.s_obr = 1;
    setTimeout(() => {
      this.change_search({ id: 1, name: 'ตามโควตา', search_id: 'fmcode' });
    }, 100);
    this.selectYear = this.year.filter(d => d.srt == 1)[0];

    setTimeout(() => {
      this.Gettimecut();
      this.GetGroup();
      //this.GetMainGrouprepair();
    }, 700);

    this.FormCutGroup.get('timecut').setValue(0);
    this.FormCutGroup.get('groupcodeedit').setValue(0);


  }
  edid_change() {
    this.edit_length = this.DataByZone.filter((el: any) => el.selected == true).length;
  }

  select_search = [
    { id: 1, name: 'ตามโควตา', search_id: 'fmcode' },
    { id: 2, name: 'ตามกลุ่มตัด', search_id: 'groupCode' },
    { id: 3, name: 'ตามกลุ่มบำรุง', search_id: 'groupCode_m' },
  ]
  loader = [false, false, false, false];

  itid: any;
  typegroup: string;
  textsearch: string;
  selectYear: any;
  txtsearch: string;
  data_select = [];
  txtFindIn = ['', '', '', '', '', '']
  textshow1: string;

  change_year(data: any) {
    this.DataByZone = [];
    console.log('change_year:', data);
  }

  change_search(data: any) {
    this.textsearch = data.search_id;
    this.textshow1 = data.name;
    console.log('data_search:', data);

  }

  fe = true;
  DataBZL: number = null;
  mydatatable1: any
  mydatatable2: any
  Loaddatabyzone() {
    this.loader[0] = true;
    let data = this.txtsearch;//(this.FormCutGroup.get('fmdata').value).trim();
    let year = this.selectYear.code_th;
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].dbo.[v_cp_data]&w=[year]='${year}'and ${this.textsearch}='${data.trim()}' order by [fmcode],[intlandno]`;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].dbo.[v_cp${year}_basic]&w=${this.textsearch}='${data.trim()}' order by [fmcode],[intlandno]`;

    if (data == '' || data == undefined) {
      alert('กรุณากรอก ข้อความที่จะค้นหา')
    }
    else if (year == '' || year == undefined) { alert('กรุณาระบุปี') }
    else {
      axios.get(url).then(res => {
        this.loader[0] = false;
        let data = res.data;
        data = data.map((item: any) => {
          return { ...item, selected: false };
        });
        this.DataByZone = data;
        this.DataBZL = data.length;
        this.txt = '';
        this.s_str = this.selectYear.status;
        /*setTimeout(() => {
          this.mydatatable1 = $(this.Tb_data1.nativeElement).DataTable();
          //this.mydatatable2 = $(this.Tb_data2.nativeElement).DataTable();
          // this.mydatatable.draw();
          // console.log(this.mydatatable);
        }, 400);*/
      }).catch(err => {
        throw (err)
      })
    }
  }

  set_unselect() {
    if (this.DataByZone) {
      this.DataByZone.forEach(item => {
        item.selected = false;
      });
      this.data_select = [];
    }
    this.edid_change();
  }

  edit_length = 0;
  async saveData() {
    let this_d = this.data_select;
    let data = this.DataByZone.filter((el: any) => el.selected == true);
    console.log('modify:', data);
    if (data.length > 0) {
      if (confirm(`ต้องการบันทึกข้อมูล | จำนวน ${data.length} แปลง หรือไม่?`)) {
        this.loader[1] = true;
        for (let i = 0; i < data.length; i++) {
          let ar0 = data[i];
          if (this.s_obr == 1) {
            this.Edittimecut([ar0.itid, this_d[0]]);
          }
          else if (this.s_obr == 2) {
            this.Editgroup_h([ar0.itid, this_d[0]]);
          }
          else if (this.s_obr == 3) {
            this.Editgroup_m([ar0.itid, this_d[0], this_d[1]]);
          }
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        alert("บันทึกข้อมูลแล้ว");
        setTimeout(() => {
          this.set_unselect();
          this.Loaddatabyzone();
          //console.log('ins', ins);
        }, 500);
        this.loader[1] = false;
      }
    }
    else alert("ยังไม่มีการเลือกข้อมูล");
  }

  s_str = 0;
  s_obr = 0;//tap

  txt = '';
  lodad_api() {
    this.Loaddatabyzone();
    this.s_str = this.selectYear.status;
    //this.dataResult = this.DataByZone;

  }

  Edittime() {
    let time = this.FormCutGroup.get('timecut').value;
    let year = this.selectYear.code;
    //this.upfirebase.updatePeriod_cut(this.s_data[0], time, year);
    console.log('time', time)

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=" + this.itid + "&Period_cut=" + time;
    axios.get(url).then(function (res) {
      console.log(res);
      if (res.data.code) {
        alert("บันทึกข้อมูลไม่สำเร็จ");
      }
      else if (res.data.rowsAffected[0] == 1) {
        alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
      }
    });
    setTimeout(() => {
      this.lodad_api();
    }, 3000);
  }

  // แก้ไขกลุ่มและงวดตัด
  Editgroupandtime() {
    // let time = this.FormCutGroup.get('timecut').value;
    let groupcode: string = (this.FormCutGroup.get('groupcodeedit').value).slice(0, 6);
    let year: string = this.selectYear.code;
    if (confirm("ต้องการแก้ไขข้อมูล")) {
      //this.upfirebase.updategroupcut(this.s_data[0], groupcode, year);
      //this.upfirebase.updatePeriod_cut(this.itid,time,year);
      //console.log('time',time)
      //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_cp_groupCode?itid=" + this.s_data[0] + "&groupCode=" + groupcode;
      let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=${this.s_data[0]}&groupCode=` + groupcode;
      axios.get(url).then(function (response) {
        //console.log(response);
        if (response.data.code) {
          alert("บันทึกข้อมูลไม่สำเร็จ");
        }
        else if (response.data.rowsAffected[0] > 0) {
          alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
        }
      });
    } else {
      alert("ยกเลิกรายการ");
    }
    this.FormCutGroup.get('timecut').setValue(0);
    //this.FormCutGroup.get('groupcodeedit').setValue(0);
    setTimeout(() => {
      this.lodad_api();
    }, 300);
  }


  Edittimecut(data) {
    let year: string = this.selectYear.code;
    this.getmapbykey(data[0]).then((maps: any) => {
      if (maps.length > 0) {
        //this.upfirebase.updateareas(year, data[0], { period_cut: data[1] },);
        //console.log('getmapbykey', data[0], data[1], year)
        //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_cp_groupCode?itid=" + data[0] + "&period_cut=" + data[1];
        let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=${data[0]}&period_cut=` + data[1];

        axios.get(url).then(function (response) {
          if (response.data.rowsAffected[0] > 0) {
            //alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          }
        });
      }
    });
  }

  Editgroup_h(data) {
    let year: string = this.selectYear.code;
    this.getmapbykey(data[0]).then((maps: any) => {
      if (maps.length > 0) {
        //this.upfirebase.updateareas(year, data[0], { groupCode: data[1] },);
        //console.log('getmapbykey', data[0], data[1], year)
        //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_cp_groupCode?itid=" + data[0] + "&groupCode=" + data[1];
        let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=${data[0]}&groupCode=` + data[1];

        axios.get(url).then(function (response) {
          if (response.data.rowsAffected[0] > 0) {
            //alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          }
        });
      }
    });
  }
  /**
   *  groupMaintenanceCode: item.gcode,
      groupMaintenanceName: item.gname,
   */

  Editgroup_m(data) {
    let year: string = this.selectYear.code;
    this.getmapbykey(data[0]).then((maps: any) => {
      if (maps.length > 0) {
        //this.upfirebase.updateareas(year, data[0] + "/DetailPlant", { groupMaintenanceCode: data[1], groupMaintenanceName: data[2] });
        console.log('getmapbykey', data, year)
        //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_cp_groupCode?itid=" + data[0] + "&groupCode_m=" + data[1];
        let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=${data[0]}&groupCode_m=` + data[1];
        axios.get(url).then(function (response) {
          if (response.data.rowsAffected[0] > 0) {
            //alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          }
        });
      }
    });
  }

  // แก้ไขตันสูญเสีย
  Edit_data(f, txt = '') {//ค่าที่จะบันทึก,คอลัมที่จะบันทึก
    // let time = this.FormCutGroup.get('timecut').value;
    let s_value = f;
    console.log('f:', f.value);
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=dbIntech.[dbo].[areas]&s=[${txt}]=${s_value}&w=itid='${this.s_data[0]}'`;
    if (confirm("ต้องการแก้ไขข้อมูล")) {
      axios.get(url).then(function (res) {
        if (res.data.code) { alert("บันทึกข้อมูลไม่สำเร็จ"); }
        else if (res.data.rowsAffected[0] > 0) { alert("บันทึกข้อมูลเรียบร้อยแล้ว!"); }
      });
    }
    else alert("ยกเลิกรายการ");

    setTimeout(() => {
      this.lodad_api();
    }, 200);
  }


  oldtime;
  oldgroup;
  oldtonlost;
  s_data: any = [];
  openedit(itid, cutg, time) {
    this.itid = itid;
    this.oldgroup = cutg;
    this.oldtime = time;
    //this.oldtonlost = tonlost;
  }

  opedcheck(itid) {
    $("#checkcut").modal('show');
    this.itid = itid;
    //this.DataByZone.filter()
  }
  open_menu(id = 0, itid) {
    this.itid = itid;
    let data = itid[0];
    if (id == 1) {
      $("#edittime").modal('show');
      this.s_data = [data.itid, data.period_cut]
    }
    else if (id == 2) {
      $("#editcut").modal('show');
      this.s_data = [data.itid, data.groupCode]
    }
    else if (id == 3) {
      $("#editrepair").modal('show');
      this.s_data = [data.itid, data.groupCode_m]
    }
    else if (id == 4) {
      $("#edittonlost").modal('show');
      this.s_data = [data.itid, data.ton_lost]
    }
    else if (id == 5) {
      $("#editcutseed").modal('show');
      this.s_data = [data.itid, data.Cutseed]
    }
    else if (id == 6) {
      let d1 = this.date2en(data.cutstart_fm), d2 = this.date2en(data.cutstop_fm)
      $("#editcutStartStop").modal('show');
      this.s_data = [data.itid, d1, d2, d1, d2]
    }
    //console.log('itid : ',this.itid);
    console.log('s_data : ', this.s_data);
  }


  // โหลดงวดตัด
  timecut: any;
  Gettimecut() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_period")
      .then(response => {
        let data = response.data.recordsets[0];
        this.timecut = data;
        // console.log(this.DataByZone);
      }).catch(err => {
        console.error(err)
      })
  }
  select_list = 99;

  // โหลดกลุ่ม
  Maincut: any[]; Mainrepair: any[];
  GetGroup() {
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_groupCode_HM]&w=status='1'`
    axios.get(url).then(res => {
      let data = res.data;
      data.sort((a, b) => a.groupcode.localeCompare(b.groupcode));
      this.Maincut = data.filter((el: any) => el.category == 'H');
      this.Mainrepair = data.filter((el: any) => el.category == 'M');
      //console.log('Maincut:', this.Maincut);
      //console.log('Mainrepair:', this.Mainrepair);
    }).catch(err => {
      throw (err)
    })
  }

  // ยืนยันพื้นที่
  Comfirmarea() {
    let id = this.FormCutGroup.get('selectconfirm').value;
    // console.log(id);
    if (id == null || id == '') { id = ''; }
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_cp_confirm_area?itid=" + this.s_data[0] + "&confirm_area=" + id;
    console.log(url);
    axios.post(url)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("บันทึกข้อมูลแล้วค่ะ");
        }
        else if (res.data.rowsAffected[0] == 0) {
          alert("บันทึกข้อมูลไม่สำเร็จ");
        }
        else if (res.data.code) {
          alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ หรือ ติดต่อ IT");
        }
      }).catch(err => { console.log(err); })
    this.lodad_api();
  }

  groupcode_m = {};
  UpdateRepaircode() {
    let groupcode = (this.FormCutGroup.get('groupcodeedit').value).slice(0, 6);
    let year = this.selectYear.code;
    this.upfirebase.updategrouprepair(this.s_data[0], groupcode, year)
    console.log('itid:' + this.itid.itid, 'year:' + year);
    setTimeout(() => {
      this.lodad_api();
    }, 2000);
  }

  UpdateCutcode() {
    let groupcode = (this.FormCutGroup.get('groupcodeedit').value).slice(0, 6);
    let year = this.selectYear.code;
    this.upfirebase.updategroupcut(this.s_data[0], groupcode, year)
    console.log('itid:' + this.itid.itid, 'year:' + year);
    setTimeout(() => {
      this.lodad_api();
    }, 2000);
  }

  getmapbykey(key = '') {
    let year = this.selectYear.code
    return new Promise((res, rej) => {
      let maps: any = [];
      this.firebase
        .list(`inst1/tx/${year}/areas`)
        .query.orderByKey()
        .equalTo(key)
        .once("value")
        .then(function (snapshot) {
          snapshot.forEach(function (childS) {
            let rec = {
              key: childS.key,
              ...childS.val(),
            }
            maps.push(rec);
          });
          //console.log('rec : ', maps.length);
          res(maps)
        }).catch((e) => {
          rej(e)
        })
    })
  }

  upfirebase2(key = '', slach = '', val) {
    let year = this.selectYear.code
    this.getmapbykey(key).then((maps: any) => {
      if (maps.length > 0) {
        //console.log('key.length', maps.length);        
        //data = maps;
        console.log('key:', maps);
        this.upfirebase.updateareas(year, key + slach, val);
        setTimeout(() => {
          this.lodad_api();
        }, 2000);
      }
      else {
        alert('key:' + key + ' ข้อมูลที่เลือกไม่พบข้อมูลที่ firebase');
      }
    });
  }

  cancel_cutstatus_fm(key = '') {
    let txtkey = key;
    var DateNow = new Date().toLocaleString("sv-SE");
    let val = {
      cutstatus: "Y",
      dateupdate: DateNow
    };

    if (confirm("ต้องการเปลี่ยนสถานะการตัดชาวไร่ เป็น กำลังตัด")) {
      //this.upfirebase2(txtkey, "/DetailPlant", val)
      let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_areas_w?itid=${key}&[cutstatus_fm]=Y&[cutstop]=`;
      axios.get(url).then(function (res) {
        if (res.data.rowsAffected[0] > 0) {
          //alert("บันทึกข้อมูลเรียบร้อยแล้ว!");
          this.Loaddatabyzone();
        }

      });
    }

  }

  set_cutstatus_fm(data) {
    let txtkey = data[0], cutstatus: string;
    if ((data[3] || data[4]) && (data[3] <= data[4])) cutstatus = 'F'
    else if (data[3] || data[4]) cutstatus = 'Y'

    var DateNow = new Date().toLocaleString("sv-SE");
    let val = {
      cutstatus: cutstatus,
      cutstart: this.date2en(data[3]),
      cutstop: this.date2en(data[4]),
      dateupdate: DateNow
    };
    //console.log('set_cutstatus_fm:', txtkey, data)
    console.log('set_cutstatus_fm_AR:', txtkey, val)

    if (confirm(`ต้องการบันทึกวันเริ่มตัด:${this.date2th(data[3])}, ตัดเสร็จ:${this.date2th(data[4])}, สถานะการตัด:${cutstatus}`)) {
      this.upfirebase2(txtkey, "/DetailPlant", val)
    }

  }

  date2en(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.DataByZone = null;
    this.itid = null;
    this.Maincut = null;
    this.timecut = null;
  }
}
